<template>
  <div v-if="completedReports.length" class="reports-completed-view">
    <template v-for="(report, key) in completedReports">
      <grid-details-component
        v-if="is_blank_report(report)"
        :key="key"
        class="custom-border"
        :display_spec="certificateReportSpecs"
        :item="report"
        :item_keys="report_blank_keys"
        :layoutClasses="getLayoutClasses()">
      </grid-details-component>
      <grid-details-component
        v-else
        :key="key"
        class="custom-border"
        :display_spec="certificateReportSpecs"
        :item="report"
        :item_keys="report_keys"
        :layoutClasses="getLayoutClasses()">
      </grid-details-component>
    </template>
  </div>
  <message-component v-else :level="'info'">
    <translate>There are no completed reports.</translate>
  </message-component>
</template>
<script>
  import { mapGetters, mapState } from 'vuex'
  import GridDetailsComponent from '@/components/layout/grid/GridDetailsComponent.vue'
  import { certificateReportSpecs, certificateSpecs } from '@/display_context/display_context'
  import MessageComponent from '@/components/layout/utility/MessageComponent'

  export default {
    name: 'reports-completed-view',
    components: {
      GridDetailsComponent,
      MessageComponent
    },
    data () {
      return {
        report_keys: ['periodDate', 'reportDate', 'reportComment', 'filesComponent', 'caseLink'],
        report_blank_keys: ['periodDate', 'reportDate', 'reportBlankReason', 'caseLink'],
        certificateSpecs: certificateSpecs,
        certificateReportSpecs: certificateReportSpecs
      }
    },
    props: {
      certificateId: {
        required: true
      }
    },
    computed: {
      ...mapState({
        certificates: state => state.certificateModule.certificates
      }),
      ...mapGetters([
        'getCertificateForId'
      ]),
      completedReports () {
        return this.certificate.reports ? this.certificate.reports.filter(report => {
          return report.isReported
        }) : []
      },
      certificate () {
        return this.getCertificateForId(this.certificateId) || {}
      }
    },
    methods: {
      getLayoutClasses () {
        let classes = []
        for (let i = 0; i < this.report_keys.length; i++) {
          classes.push('is-6-mobile is-4-tablet is-4-desktop')
        }
        return classes
      },
      is_blank_report (report) {
        return !!report.reportBlankReason
      }
    }
  }
</script>
<!--@formatter:off-->
<style lang="sass" scoped>
  .reports-completed-view
    overflow: hidden

  .custom-border
    position: relative
    border-bottom: 1px solid lightgray
</style>
